// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2c454cf","455":"e0446352","977":"55f6d25e"}[chunkId] + ".chunk.js";
};